// extracted by mini-css-extract-plugin
export default {"clubs_list":"clubsPage_clubs_list__hlt71"};